module.exports = __webpack_public_path__ + "img/ABSENCE_GRILLE_POINTAGE.8b9f900e.svg";